// Client-side UI types for the Content Calendar

export enum CalendarGenerationStatus {
  None = "None",
  GeneratingCalendar = "GeneratingCalendar",
  GeneratingContentSummaries = "GeneratingContentSummaries",
}
